import { createFileRoute, redirect } from "@tanstack/react-router";
import { requireSignedIn } from "@/client/lib/session";
import { fail } from "@/client/lib/toast";
import { linkLandingSearch } from "@/features/settings/settings-search";

export const Route = createFileRoute("/")({
  validateSearch: linkLandingSearch,
  beforeLoad: async ({ context, search, preload }) => {
    // An emailed link that did not work lands here. The reason is read before the redirect, which
    // drops it, and said once its copy loads; sign-in returns to the bare address so it is not said
    // twice.
    const { failed } = search;
    if (failed && !preload) {
      void import("@/features/settings/copy")
        .then(({ settingsCopy }) => fail(settingsCopy.linkFailed[failed]))
        .catch(reportError);
    }
    const session = await requireSignedIn(context.queryClient, "/");
    if (!session.companySlug) throw redirect({ to: "/companies/new" });
    throw redirect({ to: "/$slug", params: { slug: session.companySlug } });
  },
});
